module.exports = __webpack_public_path__ + "img/website-low.262536e6.jpg";